export type Tab = "highlights" | "week" | "offers" | "contact";

/** The open tab and, on the Week program, the day the visitor chose: 0 = Monday, null = today, the day's key everywhere else on the page. */
export interface View {
	tab: Tab;
	day: number | null;
}

/** "" is the Highlights tab, "#week" the Week program, "#week/4" its Friday, "#offers" and "#contact" the tabs of a restaurant. */
export const viewHash = (tab: Tab, day: number | null): string => {
	if (tab === "week") return day === null ? "#week" : `#week/${day}`;
	return tab === "highlights" ? "" : `#${tab}`;
};

/** The view an address hash says; anything else, or a tab the partner does not have, is the Highlights. `others`: the tabs besides Highlights and Week program that it has. */
export const parseViewHash = (hash: string, hasWeek: boolean, others: readonly Tab[] = []): View => {
	const match = /^#week(?:\/([0-6]))?$/.exec(hash);
	if (match && hasWeek) return { tab: "week", day: match[1] === undefined ? null : Number(match[1]) };
	const tab = others.find((other) => hash === `#${other}`);
	return { tab: tab ?? "highlights", day: null };
};

/** Keeps the view in the address, so that a reload opens where the visitor was. Replaces the entry: Back does not step through tabs. */
export const writeViewHash = (tab: Tab, day: number | null) => {
	const { pathname, search } = window.location;
	window.history.replaceState(window.history.state, "", `${pathname}${search}${viewHash(tab, day)}`);
};
